import { apiSlice } from '../../app/apiSlice';
import configUrlSecretaria from '../../config/urls/configUrlSecretaria';
import { useSecretariaRoutes } from '../../config/useSecretariaRoutes';
import { Secretaria } from '../../types/secretaria/Secretaria';

const endpointUrl = configUrlSecretaria.SECRETARIA_API_EP;

function createSecretaria(obj: Secretaria) {
  return {
    url: `${endpointUrl}/create`,
    method: 'POST',
    body: obj
  };
}

function updateSecretaria(obj: Secretaria) {
  return {
    url: `${endpointUrl}/${obj.id}`,
    method: 'PUT',
    body: obj
  };
}

function deleteSecretaria({ id }: { id: string }) {
  return {
    url: `${endpointUrl}/${id}`,
    method: 'DELETE'
  };
}
function getSecretarias(search: string) {
  return {
    url: `${endpointUrl}/filter?search=${search}`,
    method: 'GET'
  };
}

export const secretariaApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getSecretaria: query<Secretaria, string>({
      query: id => `${endpointUrl}/${id}`,
      providesTags: ['Secretaria']
    }),

    getSecretarias: query<Secretaria[], string>({
      query: getSecretarias,
      providesTags: ['Secretaria']
    }),

    createSecretaria1: mutation<Secretaria, Secretaria>({
      query: createSecretaria,
      invalidatesTags: ['Secretaria']
    }),

    createSecretaria: mutation<Secretaria, Secretaria>({
      query: obj => ({
        url: `${endpointUrl}/create`, // Usando a variável endpointUrl diretamente
        method: 'POST', // Método POST para criar o secretaria
        body: obj // Corpo da requisição com os dados do novo secretaria
      }),
      invalidatesTags: ['Secretaria']
    }),

    updateSecretaria: mutation<Secretaria, Secretaria>({
      query: updateSecretaria,
      invalidatesTags: ['Secretaria']
    }),

    deleteSecretaria: mutation<Secretaria, { id: string }>({
      query: deleteSecretaria,
      invalidatesTags: ['Secretaria']
    })
  })
});
export const { useGetSecretariaQuery, useGetSecretariasQuery, useCreateSecretariaMutation, useUpdateSecretariaMutation, useDeleteSecretariaMutation, useCreateSecretaria1Mutation } =
  secretariaApiSlice;
